// extracted by mini-css-extract-plugin
export default {"ul":"List_ul__0x8Ik","ol":"List_ol__Xlcro","li":"List_li__+wa14"};